<template>
  <div>
    <div class="px-4 py-6 bg-gray-400 rounded shadow mb-6 w-full">
      <div class="flex justify-between items-center mb-4">
        <div class="flex items-center">
          <div>
            <select v-model="searchContextFilter" class="select mr-2" @change="fetchData()">
              <option v-for="searchContext in searchContextData" :value="searchContext[1]">{{
                  searchContext[0]
                }}
              </option>
            </select>
          </div>
          <div>
            <input class="input mr-2" v-model="searchFilter" placeholder="Suchbegriff" @change="fetchData()"/>
          </div>
          <div>
            <select v-model="attorneyFilter" class="select mr-2" @change="fetchData()">
              <option v-for="attorney in attorneyData" :value="attorney[1]">{{ attorney[0] }}</option>
            </select>
          </div>
          <!--        <div class="mx-2">-->
          <!--          <select v-model="referrerFilter" class="select mr-2" @change="fetchData()">-->
          <!--            <option v-for="referrer in referrerData" :value="referrer[1]">{{ referrer[0] }}</option>-->
          <!--          </select>-->
          <!--        </div>-->
          <div class="flex justify-end">
            <p-check class="p-default p-fill" color="primary" v-model="archivedFilter" @change="fetchData()">abgelegt
            </p-check>
          </div>
        </div>
        <div>
          <select class="select mr-2" @change="fetchData()" v-model="sortCriteria">
            <option :value="['token', 'ASC']">Aktenzeichen (auf)</option>
            <option :value="['token', 'DESC']">Aktenzeichen (ab)</option>
            <option :value="['name', 'ASC']">Name der Akte (auf)</option>
            <option :value="['name', 'DESC']">Name der Akte (ab)</option>
            <option :value="['created_at', 'ASC']">Erstellt am (auf)</option>
            <option :value="['created_at', 'DESC']">Erstellt am (ab)</option>
            <option :value="['updated_at', 'ASC']">Zuletzt bearbeitet (auf)</option>
            <option :value="['updated_at', 'DESC']">Zuletzt bearbeitet (ab)</option>
            <option :value="['date_bought_car', 'ASC']">Kaufdatum (Diesel) (auf)</option>
            <option :value="['date_bought_car', 'DESC']">Kaufdatum (Diesel) (ab)</option>
          </select>
        </div>
      </div>
      <div class="flex items-center">
        <div class="text-gray-600 uppercase mr-2 text-sm font-bold">Spalten:</div>
        <p-check class="p-default p-fill" color="primary" v-model="columnRsv">RSV</p-check>
        <p-check class="p-default p-fill" color="primary" v-model="columnFahrzeugklasse">Fahrzeugklasse</p-check>
        <p-check class="p-default p-fill" color="primary" v-model="columnDateBoughtCar">Kaufdatum</p-check>
        <p-check class="p-default p-fill" color="primary" v-model="columnCreated">Akte erstellt am</p-check>
        <p-check class="p-default p-fill" color="primary" v-model="columnUpdated">Akte bearbeitet</p-check>
        <p-check class="p-default p-fill" color="primary" v-model="columnReferrer">Vermittler</p-check>
      </div>
    </div>

    <div class="flex justify-end mb-4">
      <p-check class="p-default p-fill" color="primary" v-model="isPreliminaryFilter" @change="fetchData()">
        Aufrissakten
      </p-check>
    </div>

    <table class="table-auto shadow rounded w-full mb-20">
      <tr class="bg-gray-200">
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('token')">Nr</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('name')">Name</th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('rsv_name')"
            v-if="columnRsv">RSV
        </th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer"
            @click="sortBy('diesel_fahrzeug_klasse')"
            v-if="columnFahrzeugklasse">Klasse
        </th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer"
            @click="sortBy('date_bought_car')"
            v-if="columnDateBoughtCar">Kaufdatum
        </th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('created_at')"
            v-if="columnCreated">Erstellt
        </th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('updated_at')"
            v-if="columnUpdated">Bearbeitet
        </th>
        <th class="px-4 py-2 text-gray-600 uppercase text-sm text-left cursor-pointer" @click="sortBy('referrer_name')"
            v-if="columnReferrer">Vermittler
        </th>
      </tr>
      <tr v-for="dossier in this.dossiers">
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap">
          <a :href="dossier.html_path" class="primary-link">
            <i class="far fa-folder-open"></i> {{ dossier.token }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap">
          <a :href="dossier.html_path" class="primary-link">
            {{ dossier.name }}
          </a>
          <div v-if="dossier.important_note" class="text-red-400 text-sm font-light">
            <i class="fas fa-exclamation-triangle"></i>
            {{ truncate(dossier.important_note, 100, true) }}
          </div>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap" v-if="columnRsv">
          <span v-if="dossier.rsv_no" class="italic text-gray-600">keine RSV</span>
          <span v-else>{{ dossier.rsv_name }}</span>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap"
            v-if="columnFahrzeugklasse">
          {{ dossier.diesel_fahrzeug_klasse }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap"
            v-if="columnDateBoughtCar">
          {{ dossier.date_bought_car | toDate }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap" v-if="columnCreated">
          {{ dossier.created_at | toDateTime }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap" v-if="columnUpdated">
          {{ dossier.updated_at | toDateTime }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left whitespace-no-wrap" v-if="columnReferrer">
          {{ dossier.referrer_name }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: [
    'searchContextData',
    'attorneyData',
    'defaultAttorneyId',
    'referrerData',
  ],
  data() {
    return {
      searchContextFilter: 'name',
      attorneyFilter: this.defaultAttorneyId,
      referrerFilter: '',
      searchFilter: '',
      archivedFilter: false,
      isPreliminaryFilter: false,
      sortCriteria: ['token', 'ASC'],
      columnRsv: false,
      columnFahrzeugklasse: false,
      columnDateBoughtCar: false,
      columnCreated: false,
      columnUpdated: false,
      columnReferrer: false,
      dossiers: [],
    }
  },
  filters: {
    toDate: function(value, format = 'DD.MM.YYYY') {
      if (value == null) {
        return value;
      }
      return moment(value).format(format);
    },
    toDateTime: function(value, format = 'DD.MM.YYYY HH:mm') {
      if (value == null) {
        return value;
      }
      return moment(value).format(format);
    }
  },
  methods: {
    fetchData: function () {
      this.$http['get']('/dossiers.json', {
        params: {
          search_context: this.searchContextFilter,
          search: this.searchFilter,
          attorney: this.attorneyFilter,
          referrer: this.referrerFilter,
          archived: this.archivedFilter,
          is_preliminary: this.isPreliminaryFilter,
          sort_field: this.sortCriteria[0],
          sort_order: this.sortCriteria[1],
        }
      }).then(response => {
        console.log(response.body)
        this.dossiers = response.body.dossiers
        this.$forceUpdate()
      }, response => {
        console.log(response)
      })
    },
    sortBy: function (field) {
      if (this.sortCriteria[0] == field) {
        if (this.sortCriteria[1] == 'ASC') {
          this.sortCriteria[1] = 'DESC';
        } else {
          this.sortCriteria[1] = 'ASC';
        }
      } else {
        this.sortCriteria[0] = field;
        this.sortCriteria[1] = 'ASC';
      }
      this.fetchData();
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) {
        return str;
      }
      const subString = str.substr(0, n - 1); // the original check
      return (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(" "))
          : subString) + "...";
    },
  },
  mounted() {
    this.fetchData();
  }
}
</script>